import React from 'react'
import PhoneCalling from "../../../assets/img/PhoneCalling.svg";

const PhoneWrapper = ({ children }) => {
    return (
        <>
            <div className="phone-field-wrapper">
                {children}
                <img src={PhoneCalling} className="imgLeft" alt=""/>
            </div>
        </>
    );
};

export default PhoneWrapper;